<div class="admin-user-container">
  <!-- 隠しリンク（CSV出力用） -->
  <a
    id="csv-download"
    style="display: none"></a>

  <!-- ヘッダー -->
  <div class="header-section">
    <div class="filter-section">
      <label>グループ:</label>
      <p-select
        [options]="userGroups"
        [(ngModel)]="selectedGroupId"
        optionLabel="name"
        optionValue="id"
        placeholder="全て"
        [showClear]="true"
        (onChange)="onGroupFilterChange()"
        [style]="{ width: '200px' }"></p-select>
      <input
        pInputText
        type="text"
        [(ngModel)]="searchText"
        (input)="onSearchChange()"
        placeholder="名前・メールで検索"
        [style]="{ width: '250px' }" />
    </div>
    <div class="action-section">
      <button
        pButton
        (click)="openRegisterDialog()"
        [disabled]="isLoading">
        <i
          class="pi pi-plus"
          aria-hidden="true"></i>
        ユーザ登録
      </button>
    </div>
  </div>

  <!-- ユーザ一覧テーブル -->
  <p-table
    [value]="filteredUsers"
    [loading]="isLoading"
    [paginator]="true"
    [rows]="100"
    [rowsPerPageOptions]="[10, 20, 50, 100]"
    class="p-datatable-sm p-datatable-striped">
    <ng-template #header>
      <tr>
        <th style="width: 80px">ID</th>
        <th>名前</th>
        <th>メール</th>
        <th>グループ</th>
        <th>権限</th>
        <th style="width: 200px">操作</th>
      </tr>
    </ng-template>
    <ng-template
      #body
      let-user>
      <tr>
        <td>{{ user.id }}</td>
        <td>{{ user.name || '-' }}</td>
        <td>
          <div>{{ user.email }}</div>
          <p-tag
            [value]="getRoleLabel(user.userRole)"
            [severity]="getRoleSeverity(user.userRole)"
            [rounded]="true"
            class="role-tag"></p-tag>
        </td>
        <td>{{ user.userGroup?.name || '-' }}</td>
        <td>
          <div class="functions-tags">
            @for (func of user.functions; track func) {
              <p-tag
                [value]="getFunctionLabel(func)"
                [severity]="getFunctionSeverity(func)"
                [rounded]="true"
                class="function-tag"></p-tag>
            }
            @if (!user.functions || user.functions.length === 0) {
              <span>-</span>
            }
          </div>
        </td>
        <td>
          <button
            pButton
            iconOnly
            class="p-button-sm p-button-outlined"
            pTooltip="権限編集"
            (click)="openEditFunctionsDialog(user)"
            [disabled]="isLoading">
            <i
              class="pi pi-pencil"
              aria-hidden="true"></i>
          </button>
          <button
            pButton
            iconOnly
            class="p-button-sm p-button-outlined p-button-secondary"
            pTooltip="パスワード変更"
            (click)="confirmResetPassword(user)"
            [disabled]="isLoading"
            style="margin-left: 0.5rem">
            <i
              class="pi pi-key"
              aria-hidden="true"></i>
          </button>
          <button
            pButton
            iconOnly
            class="p-button-sm p-button-outlined p-button-danger"
            pTooltip="削除"
            (click)="confirmDeleteUser(user)"
            [disabled]="isLoading"
            style="margin-left: 0.5rem">
            <i
              class="pi pi-trash"
              aria-hidden="true"></i>
          </button>
        </td>
      </tr>
    </ng-template>
    <ng-template #emptymessage>
      <tr>
        <td
          colspan="6"
          class="text-center">
          ユーザが見つかりません
        </td>
      </tr>
    </ng-template>
  </p-table>

  <!-- 確認ダイアログ -->
  <p-confirmdialog></p-confirmdialog>

  <!-- 登録ダイアログ -->
  <p-dialog
    header="ユーザ登録"
    [(visible)]="showRegisterDialog"
    [modal]="true"
    [style]="{ width: '600px' }"
    [closable]="true">
    <div class="register-form">
      <div class="form-group">
        <label>
          グループ
          <span class="required">*</span>
        </label>
        <p-select
          [options]="userGroups"
          [(ngModel)]="registerGroupId"
          optionLabel="name"
          optionValue="id"
          placeholder="選択してください"
          [style]="{ width: '100%' }"></p-select>
      </div>

      <div class="form-group">
        <label>権限</label>
        <div class="checkbox-group">
          @for (opt of functionOptions; track opt) {
            <div class="checkbox-item">
              <p-checkbox
                [value]="opt.value"
                [(ngModel)]="registerFunctions"
                [inputId]="'func-' + opt.value"></p-checkbox>
              <label [for]="'func-' + opt.value">{{ opt.label }}</label>
            </div>
          }
        </div>
      </div>

      <div class="form-group">
        <label>
          ユーザ情報
          <span class="required">*</span>
        </label>
        <small class="help-text">1行につき1ユーザ。「名前, メールアドレス」形式で入力してください。</small>
        <textarea
          pInputTextarea
          [(ngModel)]="registerUsersText"
          [rows]="8"
          placeholder="田中太郎, tanaka@example.com&#10;鈴木花子, suzuki@example.com"
          [style]="{ width: '100%' }"></textarea>
      </div>
    </div>

    <ng-template #footer>
      <button
        pButton
        class="p-button-text"
        (click)="showRegisterDialog = false">
        <i
          class="pi pi-times"
          aria-hidden="true"></i>
        キャンセル
      </button>
      <button
        pButton
        (click)="doRegister()"
        [disabled]="!canRegister() || isLoading"
        [loading]="isLoading">
        <i
          [class]="isLoading ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
          aria-hidden="true"></i>
        登録
      </button>
    </ng-template>
  </p-dialog>

  <!-- 登録結果ダイアログ -->
  <p-dialog
    header="登録完了"
    [(visible)]="showResultDialog"
    [modal]="true"
    [style]="{ width: '700px' }"
    [closable]="true">
    <div class="result-content">
      <p>以下のユーザを登録しました:</p>

      <p-table
        [value]="registeredUsers"
        class="p-datatable-sm">
        <ng-template #header>
          <tr>
            <th>ユーザID</th>
            <th>メール</th>
            <th>パスワード</th>
          </tr>
        </ng-template>
        <ng-template
          #body
          let-user>
          <tr>
            <td>{{ user.userId }}</td>
            <td>{{ user.email }}</td>
            <td>
              <code>{{ user.password }}</code>
            </td>
          </tr>
        </ng-template>
      </p-table>

      <div class="warning-message">
        <i class="pi pi-exclamation-triangle"></i>
        パスワードはこの画面でのみ表示されます。必ず控えてください。
      </div>
    </div>

    <ng-template #footer>
      <button
        pButton
        class="p-button-secondary"
        (click)="downloadRegisteredUsersCsv()">
        <i
          class="pi pi-download"
          aria-hidden="true"></i>
        CSVダウンロード
      </button>
      <button
        pButton
        (click)="closeResultDialog()">
        <i
          class="pi pi-times"
          aria-hidden="true"></i>
        閉じる
      </button>
    </ng-template>
  </p-dialog>

  <!-- パスワード変更結果ダイアログ -->
  <p-dialog
    header="パスワード変更完了"
    [(visible)]="showPasswordDialog"
    [modal]="true"
    [style]="{ width: '400px' }"
    [closable]="true">
    @if (resetPasswordResult) {
      <div class="password-result">
        <div class="result-item">
          <label>ユーザID:</label>
          <span>{{ resetPasswordResult.userId }}</span>
        </div>
        <div class="result-item">
          <label>新しいパスワード:</label>
          <code>{{ resetPasswordResult.password }}</code>
        </div>
        <div class="warning-message">
          <i class="pi pi-exclamation-triangle"></i>
          パスワードはこの画面でのみ表示されます。必ず控えてください。
        </div>
      </div>
    }

    <ng-template #footer>
      <button
        pButton
        (click)="closePasswordDialog()">
        <i
          class="pi pi-times"
          aria-hidden="true"></i>
        閉じる
      </button>
    </ng-template>
  </p-dialog>

  <!-- 権限編集ダイアログ -->
  <p-dialog
    header="権限編集"
    [(visible)]="showEditFunctionsDialog"
    [modal]="true"
    [style]="{ width: '500px' }"
    [closable]="true">
    @if (editTargetUser) {
      <div class="edit-functions-form">
        <div class="edit-target-info">
          <label>対象:</label>
          <span>{{ editTargetUser.name || editTargetUser.email }}</span>
        </div>
        <div class="form-group">
          <label>権限</label>
          <div class="checkbox-group">
            @for (opt of functionOptions; track opt) {
              <div class="checkbox-item">
                <p-checkbox
                  [value]="opt.value"
                  [(ngModel)]="editFunctions"
                  [inputId]="'edit-func-' + opt.value"></p-checkbox>
                <label [for]="'edit-func-' + opt.value">{{ opt.label }}</label>
              </div>
            }
          </div>
        </div>
      </div>
    }

    <ng-template #footer>
      <button
        pButton
        class="p-button-text"
        (click)="showEditFunctionsDialog = false">
        <i
          class="pi pi-times"
          aria-hidden="true"></i>
        キャンセル
      </button>
      <button
        pButton
        (click)="doUpdateFunctions()"
        [disabled]="isLoading"
        [loading]="isLoading">
        <i
          [class]="isLoading ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
          aria-hidden="true"></i>
        保存
      </button>
    </ng-template>
  </p-dialog>
</div>
